export function markNotificationsRead(fetch: GlobalFetch) {
  return async function(id: number | number[]) {
    const body = {
      id: id,
    }

    const response = await fetch.fetch(`/api/v2/notification/read`, {
      body: JSON.stringify(body),
      method: 'POST',
    })
    return await response.json()
  }
}
